<template>
	<BreadcrumbItem
		v-if="!isMobile || isFirstOrLastItem(index, props.items)"
		class="text-primary"
		:class="props.class"
		@click="handleBreadcrumbClick(item)"
	>
		<BreadcrumbLink
			:to="item.route"
			:class="
				cn(
					{
						'cursor-default font-medium': isLastItem(index, props.items),
						'cursor-pointer text-primary underline decoration-white-dark-4 underline-offset-[6px] hover:decoration-primary':
							!isLastItem(index, props.items),
						'pointer-events-none': isLastItem(index, props.items)
					},
					props.class
				)
			"
			class="hover:text-primary"
		>
			{{ item.label }}
		</BreadcrumbLink>
	</BreadcrumbItem>

	<BreadcrumbItem
		v-if="isMobile && mobileContextMenuIndex === index"
		class="text-primary"
		:class="props.class"
	>
		<BreadcrumbMobileDropdownMenu :items="mobileBreadcrumbItems" />
	</BreadcrumbItem>

	<BreadcrumbSeparator
		v-if="shouldShowSeparator(index)"
		class="cursor-default text-primary-light-1"
		:class="props.class"
	/>
</template>

<script setup lang="ts">
import { computed, type HTMLAttributes } from 'vue';
import {
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbMobileDropdownMenu,
	BreadcrumbSeparator,
	isFirstItem,
	isFirstOrLastItem,
	isLastItem,
	type BreadcrumbEmits,
	type BreadcrumbProps
} from '.';
import { cn } from '@/utils';

const props = defineProps<{
	isMobile: boolean;
	item: BreadcrumbItem;
	items: BreadcrumbProps['items'];
	mobileBreadcrumbItems: BreadcrumbItem[];
	index: number;
	class?: HTMLAttributes['class'];
}>();

const emit = defineEmits<BreadcrumbEmits>();

const mobileContextMenuIndex = computed<number | null>(() =>
	props.items.length > 2 ? 1 : null
);

function handleBreadcrumbClick(item: BreadcrumbItem) {
	emit('breadcrumb-clicked', item);
}

function shouldShowSeparator(index: number) {
	if (!props.isMobile) return !isLastItem(index, props.items);

	return mobileContextMenuIndex.value === index || isFirstItem(index);
}
</script>
